export const DELETE_CONTENT_TITLE = "cards_library.delete_content_link";
export const DELETE_VIEWED_CARD_TITLE = "cards_library.remove_viewed_card_modal";
export const DELETE_FAVORITE_CARD_TITLE = "cards_library.remove_favorite_card";
export const DELETE_ALL_VIEWED_CARD_TITLE = "cards_library.remove_all_viewed_cards";
export const DELETE_ALL_FAVORITES_CARD_TITLE = "cards_library.remove_all_favorite_cards";
export const DELETE_CARD_TITLE = "cards_library.delete_individual_card";
export const DELETE_HASHTAG_TITLE = "cards_library.delete_hashtag";
export const DELETE_PROMO_CODE_TITLE = "cards_library.delete_promo_code";
export const DELETE_DESCRIPTION = "cards_library.remove_viewed_card_modal";
export const CANCEL_YOUR_PLAN_TITLE = "dialogs.cancel_plan.title";
export const CANCEL_YOUR_PLAN_DESCRIPTION = "dialogs.cancel_plan.description";
export const   ALLOWED_KEYS= /^[0-9]$/ ;
